import { Dimension } from '@pubstack/common/src/analytics/dimension'
import { UserSessionMetricsByTime } from '@pubstack/common/src/analytics/query'
import { CurrencySymbol } from '@pubstack/common/src/currency'
import { DateTime } from 'luxon'
import { FunctionComponent } from 'react'
import { useAnalyticsQueryTanstack } from '~/api/analytics/analytics-query.api'
import { contextMinusOneWeek } from '~/modules/analytics/utils'
import { Context } from '~/state'
import { WithClassName } from '~/types/utils'
import { PureUserSessionTimeline } from './PureUserSessionTimeline'

const DIMENSIONS: Dimension[] = ['tagId', 'device', 'country']

type UserSessionTimelineProps = WithClassName & { context: Context; currencySymbol: CurrencySymbol }
export const UserSessionTimeline: FunctionComponent<UserSessionTimelineProps> = ({ context, currencySymbol, className }) => {
  const analyticsQueryTime = useAnalyticsQueryTanstack<UserSessionMetricsByTime>('user-session.metrics.by.time', DIMENSIONS, context, {})
  const analyticsQueryTimeComparison = useAnalyticsQueryTanstack<UserSessionMetricsByTime>('user-session.metrics.by.time', DIMENSIONS, contextMinusOneWeek(context), {})

  const onMetricChange = (_metric: string) => {}

  return (
    <PureUserSessionTimeline
      className={className}
      isLoading={analyticsQueryTime.isFetching}
      error={analyticsQueryTime.isError}
      empty={!analyticsQueryTime.isLoading && !analyticsQueryTime.data?.epoch.length}
      onRefreshClick={() => {}}
      data={analyticsQueryTime.data ?? { epoch: [] }}
      comparisonData={analyticsQueryTimeComparison.data ?? { epoch: [] }}
      currencySymbol={currencySymbol}
      onMetricChange={onMetricChange}
      currentEpoch={DateTime.now()}
      timezone={context.timeRange.tz}
    />
  )
}
